import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import moment from 'moment';
import _ from 'lodash';
import { CSVDownload } from 'react-csv/lib';

import { get as getTeacherAggregateAnalytics } from 'actions/teacher-analytics';
import { median } from './utils/data-parser';
import PersonalDetails from './components/personal-details';
import TabComponentTeacher from './components/tabs-teacher';

import { Header, Statistic, Button } from 'semantic-ui-react';

export class TeacherAggregateTable extends PureComponent {
  static propTypes = {
    teacherAggregateAnalytics: PropTypes.shape({}),
    actions: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      processedData: null,
      teacherCount: 0,
      loadCSV: false,
    };
  }

  static getDerivedStateFromProps(
    { teacherAggregateAnalytics, queryObj, loadCSV },
    prevState,
  ) {
    let newState = {};
    const teacherAggregateAnalyticsGet = store.get(
      teacherAggregateAnalytics,
      'ANALYTICS',
      queryObj,
    );
    if (teacherAggregateAnalyticsGet) {
      if (
        teacherAggregateAnalyticsGet.data &&
        prevState.data !== teacherAggregateAnalyticsGet.data
      ) {
        newState['data'] = teacherAggregateAnalyticsGet.data.teachers_data;
        newState['teacherCount'] = teacherAggregateAnalyticsGet.data.teachers_count;
        newState['loading'] = false;
        newState['loadCSV'] = loadCSV;
      }
    }
    if (newState === {}) {
      return null;
    }
    return newState;
  }

  componentDidUpdate(prevProps) {
    const { queryObj, actions } = this.props;
    if (!_.isEqual(queryObj, prevProps.queryObj)) {
      actions.getTeacherAggregateAnalytics('ANALYTICS', queryObj);
      this.setState({
        loading: true,
      });
    }
  }

  componentDidMount() {
    const { actions, queryObj } = this.props;
    actions.getTeacherAggregateAnalytics('ANALYTICS', queryObj);
    this.setState({
      loading: true,
    });
  }

  fetchData = (state, instance) => {
    const { setPageNumberSizeSortedFiltered, queryObj } = this.props;
    if (
      state.page + 1 !== queryObj.page ||
      state.pageSize !== queryObj.page_size ||
      state.sorted.length > 0
    ) {
      setPageNumberSizeSortedFiltered(
        state.page + 1,
        state.pageSize,
        state.sorted[0],
        state.filtered,
        false,
      );
      this.setState({
        loading: true,
      });
    }
  };

  getCSVData = () => {
    const { setPageNumberSizeSortedFiltered } = this.props;
    const { teacherCount } = this.state;

    setPageNumberSizeSortedFiltered(1, teacherCount, null, null, true);
  };
  makeDownloadable = data => {
    let outData = data.map(std => {
      let meanDoubtToCallTimeList = [];
      std.doubt_to_call_time.forEach(dbtCall => {
        if (dbtCall.length > 0) {
          meanDoubtToCallTimeList.push(_.sum(dbtCall) / dbtCall.length);
        }
      });
      let medianDbtToCallTime = median(meanDoubtToCallTimeList) / 60.0;
      let itemsAttempted = std.num_items_attempted.filter(itm => itm !== 0);
      let itemsAttempted1 = median(itemsAttempted).toFixed(1);
      let indian = std.student_region_dict['INDIA']
        ? Object.values(std.student_region_dict['INDIA']).length
        : 0;
      let american = std.student_region_dict.USA
        ? Object.values(std.student_region_dict['USA']).length
        : 0;
      let completion = std.avg_completion > 0 ? std.avg_completion : 'NA';
      let doubts = _.sum(std.num_doubts);
      return {
        name: std.name,
        joined_on: std.dt_joined,
        ratings: std.avg_rating,
        class_taken: std.classes_attended,
        attendance: std.attendance,
        call_time: std.avg_call_time,
        doubt_to_call_time: medianDbtToCallTime,
        doubts: doubts,
        time_on_worksheet: std.avg_time_on_worksheets,
        items: itemsAttempted1,
        number_of_slot: std.num_slots,
        indian_student: indian,
        usa_student: american,
        syllabus_completion: completion,
      };
    });
    return outData;
  };

  render() {
    const { queryObj } = this.props;
    const { data, loading, teacherCount, loadCSV } = this.state;
    return (
      <div>
        {data && (
          <div>
            {loadCSV === false ? (
              <Button onClick={this.getCSVData} color={'olive'} content={' CSV'} />
            ) : (
              <CSVDownload data={this.makeDownloadable(data)} target="_blank" />
            )}
          </div>
        )}
        {data && (
          <ReactTable
            columns={[
              {
                Header: 'Personal Details',
                headerClassName: 'personal-details',
                columns: [
                  {
                    Header: 'Name',
                    id: 'name',
                    sortable: true,
                    sortMethod: (a, b) => (a.name > b.name ? 1 : -1),
                    accessor: d => <PersonalDetails data={d} />,
                    maxWidth: 235,
                  },
                  {
                    Header: 'Joined On',
                    sortable: true,
                    id: 'dt_joined',
                    accessor: d => {
                      var a = moment(d.dt_joined);
                      var b = moment(new Date().toString());
                      var months = b.diff(a, 'months');
                      return (
                        <Header as="h4">
                          {a.format('DD-MM-YYYY')}
                          <br />({months} months ago)
                        </Header>
                      );
                    },
                    maxWidth: 120,
                  },
                  {
                    Header: 'Ratings',
                    id: 'avg_rating',
                    sortable: true,
                    accessor: d => (
                      <Statistic text size="mini">
                        <Statistic.Value>
                          {d.rating.length === 0 || d.avg_rating === -1
                            ? 'NA'
                            : d.avg_rating.toFixed(1)}
                        </Statistic.Value>
                        <Statistic.Label>{d.rating.length} ratings</Statistic.Label>
                      </Statistic>
                    ),
                    maxWidth: 100,
                  },
                ],
              },
              {
                Header: 'Classroom Interactions',
                headerClassName: 'classroom-interactions',
                columns: [
                  {
                    Header: '# Classes Taken/Scheduled',
                    id: 'classes_attended',
                    sortable: true,
                    maxWidth: 120,
                    accessor: d => (
                      <Statistic
                        size="mini"
                        color={
                          d.classes_attended < 6 * d.months_since_joined
                            ? 'red'
                            : d.classes_attended < 8 * d.months_since_joined
                            ? 'yellow'
                            : 'green'
                        }
                      >
                        <Statistic.Value>
                          {d.classes_attended}/{d.classes_total}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Attendance',
                    id: 'attendance',
                    sortable: true,
                    maxWidth: 100,
                    accessor: d => {
                      let attendance = d.attendance * 100;
                      return (
                        <Statistic
                          size="tiny"
                          color={
                            attendance < 95 ? 'red' : attendance < 98 ? 'yellow' : 'green'
                          }
                        >
                          <Statistic.Value>{attendance.toFixed(1)}%</Statistic.Value>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Call Time (avg) /Student/Class',
                    id: 'avg_call_time',
                    sortable: true,
                    maxWidth: 110,
                    accessor: d => {
                      let callsMadeTime = d.total_call_time.filter(tm => tm !== 0);
                      return (
                        <Statistic
                          size="mini"
                          color={median(callsMadeTime) < 5 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {median(callsMadeTime).toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins/student</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Doubt to Call Time/Student/Class',
                    id: 'doubt_to_call_time',
                    sortable: false,
                    maxWidth: 70,
                    accessor: d => {
                      let meanDoubtToCallTimeList = [];
                      d.doubt_to_call_time.forEach(dbtCall => {
                        if (dbtCall.length > 0) {
                          meanDoubtToCallTimeList.push(_.sum(dbtCall) / dbtCall.length);
                        }
                      });
                      let medianDbtToCallTime = median(meanDoubtToCallTimeList) / 60.0;
                      return (
                        <Statistic
                          size="mini"
                          color={medianDbtToCallTime > 8 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {medianDbtToCallTime.toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: '#Doubts Resolved/Student/Class',
                    id: 'sum_doubts',
                    sortable: false,
                    maxWidth: 110,
                    accessor: d => {
                      return (
                        <Statistic size="mini">
                          <Statistic.Value>{_.sum(d.num_doubts)}</Statistic.Value>
                          <Statistic.Label>
                            @{' '}
                            {d.num_doubts.length > 0
                              ? (_.sum(d.num_doubts) / d.num_doubts.length).toFixed(1)
                              : 'NA'}{' '}
                            doubt <br />
                            per class
                          </Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Time on Worksheet/Student/Class',
                    id: 'avg_time_on_worksheets',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => {
                      return (
                        <Statistic
                          size="mini"
                          color={d.avg_time_on_worksheets < 35 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {d.avg_time_on_worksheets.toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: '#Items/Class/Student',
                    id: 'avg_items_attempted_correctly',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => {
                      let itemsAttempted = d.num_items_attempted.filter(itm => itm !== 0);
                      return (
                        <Statistic
                          size="mini"
                          color={median(itemsAttempted) < 17 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {median(itemsAttempted).toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>/class</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                ],
              },
              {
                Header: 'Metrics',
                headerClassName: 'teacher-metrics',
                columns: [
                  {
                    Header: "#Teachers' Classes/week",
                    id: 'num_slots',
                    sortable: true,
                    maxWidth: 80,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>{d.num_slots}</Statistic.Value>
                        <Statistic.Label>
                          classes/
                          <br />
                          week
                        </Statistic.Label>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'India #Students ',
                    id: 'num_students_india',
                    sortable: false,
                    maxWidth: 80,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.student_region_dict['INDIA']
                            ? Object.values(d.student_region_dict['INDIA']).length
                            : 0}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'USA #Students ',
                    id: 'num_students_usa',
                    sortable: false,
                    maxWidth: 80,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.student_region_dict.USA
                            ? Object.values(d.student_region_dict['USA']).length
                            : 0}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Syllabus Completion/Student/Month',
                    id: 'avg_completion',
                    sortable: true,
                    maxWidth: 100,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.avg_completion !== -1
                            ? (d.avg_completion * 100).toFixed(1) + '%'
                            : 'NA'}
                        </Statistic.Value>
                        <Statistic.Label>
                          per student per
                          <br />
                          month
                        </Statistic.Label>
                      </Statistic>
                    ),
                  },
                ],
              },
              //Completion Metric Plus Utilization Metrics
              /*

            //Draw Graphs from components from here.
            */
            ]}
            SubComponent={row => {
              return <TabComponentTeacher data={row.original} />;
            }}
            data={data}
            manual // Forces table not to paginate or sort automatically, so we can handle it server-side
            onFetchData={this.fetchData}
            loading={loading} // Display the loading overlay when we need it
            pages={Math.ceil(teacherCount / queryObj.page_size)}
            pageSize={queryObj.page_size}
            showPagination
            page={queryObj.page - 1}
            className="-striped -highlight"
            multiSort={false}
          />
        )}
      </div>
    );
  }
}

export default connect(
  ({ teacherAggregateAnalytics }) => ({
    teacherAggregateAnalytics: teacherAggregateAnalytics,
  }),
  dispatch => ({
    actions: bindActionCreators({ getTeacherAggregateAnalytics }, dispatch),
  }),
)(TeacherAggregateTable);
